import { Seo } from "@/components/Seo";
import { Hero } from "@/components/home/Hero";
import { TrustBar } from "@/components/home/TrustBar";
import { EditorialMarquee } from "@/components/Marquee";
import { ServicesPreview } from "@/components/home/ServicesPreview";
import { SafeSpecialist } from "@/components/home/SafeSpecialist";
import { Manifesto } from "@/components/home/Manifesto";
import { WorkPreview } from "@/components/home/WorkPreview";
import { ReviewsPreview } from "@/components/home/ReviewsPreview";
import { ServiceAreaPreview } from "@/components/home/ServiceAreaPreview";
import { AboutPreview } from "@/components/home/AboutPreview";
import { CareersCTA } from "@/components/home/CareersCTA";
import { FaqPreview } from "@/components/home/FaqPreview";
import { ContactCTA } from "@/components/home/ContactCTA";

export default function Home() {
  return (
    <>
      <Seo
        title="Safe & Vault Specialists in Norwalk, CA"
        description="Velasco Lock and Safe — specialized safe and vault services in Norwalk and throughout Southern California. Safe opening, safe moving, heavy safe moving, removal, disposal, lock and keypad repair. Licensed, bonded and insured. Call (562) 716-4447."
        path="/"
      />
      <Hero />
      <TrustBar />
      <EditorialMarquee />
      <ServicesPreview />
      <SafeSpecialist />
      <Manifesto />
      <WorkPreview />
      <ReviewsPreview />
      <ServiceAreaPreview />
      <AboutPreview />
      <CareersCTA />
      <FaqPreview />
      <ContactCTA />
    </>
  );
}
